import React from 'react'
import {Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import clsx from 'clsx';
import WorkableIconDeleteButton from 'components/button/WorkableIconDeleteButton';
import WorkableIconEditButton from 'components/button/WorkableIconEditButton';

const style = theme => ({
    root: {
        marginRight: theme.spacing(1),
    },
    disableDelete: {
        marginRight: theme.spacing(3)
    }
})

function ConditionElement(
    {
        classes,
        name,
        index,
        id,
        formikProps,
        onEdit,
        onDelete,
        disableDelete = false,
        disabled,
    }) {

    return (
        <GridBlock
            wrap='nowrap'
            alignItems='center'
            className={classes.root}
        >
            <Typography variant='body1'>
                {name}
            </Typography>
            <WorkableIconEditButton
                onClick={onEdit}
                className={clsx({
                    [classes.disableDelete]: disableDelete
                })}
            />
            {!disableDelete &&
            <WorkableIconDeleteButton
                onClick={() => onDelete(index)}
                disabled={disabled}
            />
            }
        </GridBlock>
    )
}

ConditionElement.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(ConditionElement);